import { useState, useEffect } from "react";
import "./RotateDevice.css";

/**
 * Overlay che invita l'utente a ruotare il dispositivo in landscape.
 * Appare solo se il dispositivo è in portrait E lo schermo è <= maxWidth.
 * Si nasconde automaticamente quando il dispositivo viene ruotato in landscape.
 *
 * Props:
 * - active: boolean — se true l'overlay è potenzialmente visibile (es. fullscreen attivo)
 * - maxWidth: number — soglia in px sotto cui mostrare l'overlay (default 480)
 */
const RotateDevice = ({ active, maxWidth = 480 }) => {
    const [isPortrait, setIsPortrait] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        if (!active) return;

        const portraitMq = window.matchMedia("(orientation: portrait)");
        const widthMq = window.matchMedia(`(max-width: ${maxWidth}px)`);

        const update = () => {
            setIsPortrait(portraitMq.matches);
            setIsSmallScreen(widthMq.matches);
        };

        update();

        portraitMq.addEventListener("change", update);
        widthMq.addEventListener("change", update);

        return () => {
            portraitMq.removeEventListener("change", update);
            widthMq.removeEventListener("change", update);
        };
    }, [active, maxWidth]);

    if (!active || !isPortrait || !isSmallScreen) return null;

    return (
        <div className="rotate-device-overlay">
            <div className="rotate-device-content">
                <div className="rotate-device-icon">
                    <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="30" y="10" width="40" height="70" rx="6" stroke="currentColor" strokeWidth="4" />
                        <rect x="45" y="72" width="10" height="3" rx="1.5" fill="currentColor" />
                    </svg>
                </div>
                <p className="rotate-device-text">Ruota il dispositivo per una visualizzazione migliore</p>
            </div>
        </div>
    );
};

export default RotateDevice;
